import React from 'react';
import useHistoryBackClose from '../../hooks/useHistoryBackClose';

// YouTube popup player.
// - Shorts (9:16): portrait container
// - All others: 16:9
// - Browser / mobile back closes the dialog (does not leave the page)
const VideoModal = ({ video, onClose }) => {
  useHistoryBackClose(!!video, onClose, 'kathaVideoModal');

  if (!video) return null;

  const isShort = (video.category || '') === 'shorts';

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-90 backdrop-blur-sm p-4"
      style={{ zIndex: 9999 }}
      role="dialog"
      aria-modal="true"
      aria-label={video.title}
      onClick={onClose}
    >
      {/* Shorts: narrow portrait; others: wide */}
      <div
        className="flex flex-col items-center"
        style={{ width: isShort ? 'min(340px, 90vw)' : '100%', maxWidth: isShort ? undefined : '56rem' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Title + Close */}
        <div className="flex items-center justify-between gap-4 mb-3 w-full">
          <h3 className="text-white text-base md:text-xl font-semibold line-clamp-2">
            {video.title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="flex-shrink-0 w-10 h-10 bg-white bg-opacity-20 hover:bg-opacity-30 text-white rounded-full flex items-center justify-center transition-colors"
            aria-label="Close video"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        {/* Player */}
        <div
          className="relative w-full overflow-hidden rounded-xl bg-black shadow-2xl"
          style={isShort
            ? { aspectRatio: '9 / 16', maxHeight: '78vh' }
            : { aspectRatio: '16 / 9' }
          }
        >
          <iframe
            src={`https://www.youtube.com/embed/${video.youtubeId}?autoplay=1&rel=0&modestbranding=1&fs=1`}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
            allowFullScreen
            className="absolute inset-0 w-full h-full"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
